webpackJsonp([31],{

/***/ "m5ZQ":
/***/ (function(module, exports, __webpack_require__) {

var mariSmithTutorials = (function () {
    function mariSmithTutorials() {
    }
    return mariSmithTutorials;
}());
angular.module('animatronApp.wave.mariSmithTutorials', []).component('mariSmithTutorials', {
    controller: mariSmithTutorials,
    templateUrl: __webpack_require__("wL/W")
});


/***/ }),

/***/ "wL/W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/mari-smith-tutorials_daf6efa014bc92a24b35e72a8eec07c9.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/31-28dc41a6a889e793a2e2.min.js